import React from 'react';
import { motion } from 'framer-motion';
import { Search, Link as LinkIcon, MousePointerClick } from 'lucide-react';
export function OfferSection() {
  const benefits = [{
    icon: <Search className="text-nova-gold" size={24} data-id="element-192" />,
    title: 'SEO Local Ready',
    description: 'Estructura técnica para que Google ame su página y lo suba en los resultados de búsqueda locales.'
  }, {
    icon: <LinkIcon className="text-nova-gold" size={24} data-id="element-193" />,
    title: 'Integración Total',
    description: 'Conectamos sus reseñas de Google y sus fotos de Instagram automáticamente para generar confianza.'
  }, {
    icon: <MousePointerClick className="text-nova-gold" size={24} data-id="element-194" />,
    title: 'Botón de Acción Inmediata',
    description: 'Un clic para llamar o un clic para abrir WhatsApp. Sin fricciones, directo a la venta.'
  }];
  return <section id="servicios" className="py-24 bg-nova-navy-dark relative border-t border-nova-navy-light/20" data-id="element-195">
      <div className="container mx-auto px-4 md:px-6" data-id="element-196">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-197">
          <motion.span initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-nova-gold font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-198">
            El Pack de Crecimiento Local
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight" data-id="element-199">
            Una presencia digital de alto nivel por menos de lo que cuesta una
            cena.
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-200">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2 + index * 0.1
        }} className="bg-nova-navy-light/10 border border-nova-navy-light/30 rounded-2xl p-8 hover:bg-nova-navy-light/20 transition-all duration-300" data-id="element-201">
              <div className="w-14 h-14 bg-nova-gold/10 rounded-xl flex items-center justify-center mb-6" data-id="element-202">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-203">
                {benefit.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-204">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}